import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Checkbox from '@material-ui/core/Checkbox';
import Check from '@material-ui/icons/Check';
import { withStyles } from '@material-ui/core/styles';
import styles from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";

const dbList = [];

const Single = props => {
  const { permObj, classes } = props;
  const actionsDivs = props.actions.map((ac,i) => {
    const id = props.actions[i].id,
          showLabel = props.actions[i].showLabel,
          label = props.actions[i].subCategory,
          unCheck = props.actions[i].unCheck,
          name = props.actions[i].name;
    return (
      <div style={{padding:'20px 0 0 0'}} key={`actions-${i}`}>
        {showLabel && <div className="pilled2-relative"><h4 className="pilled2">{label}</h4></div>}
        {props.actions[i].name}
        <Checkbox
          tabIndex={-1}
          checkedIcon={<Check className={classes.checkedIcon} />}
          icon={<Check className={classes.uncheckedIcon} />}
          classes={{checked: classes.checked}}
          checked={permObj.hasOwnProperty(id)}
          onClick={() => {
            
            if (permObj.hasOwnProperty(id)) {
              delete permObj[id];
            } else {
              permObj[id] = [null];
            };
            if (unCheck) {
              
              delete permObj[unCheck];
              props.choosePerm(permObj);
            } else {
              props.choosePerm(permObj);
            }
          }}
        />
      </div>
    )
  });
  return actionsDivs;
}

const HasDBs = props => {
  const { permObj, classes } = props;
  const showLabel = props.actions[0].showLabel,
        label = props.actions[0].subCategory == 'GMP' ? 'TPP' : props.actions[0].subCategory;
  return (
  <div style={{marginBottom:'40px'}}>
    {showLabel && <div className="pilled2-relative"><h4 className="pilled2">{label}</h4></div>}
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>
          </TableCell>
          {dbList.map((db, i) => {
            return <TableCell align="right" key={`tcr${i}`}><div className="db-cell" style={{backgroundColor:db.color}}>{db.name.split('_')[0]}</div></TableCell>
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {props.actions.map((n, i) => {
            return (
              <TableRow
                hover
                role="checkbox"
                tabIndex={-1}
                key={`trr${i}`}
              >
                <TableCell align="left">
                  <div style={{textAlign:'left'}}>{n.name}</div>
                </TableCell>
                {dbList.map((db, ii) => {
                  const isSendToDirect = permObj[9] ? permObj[9].indexOf(db.name) !== -1 ? true : false : false;
                  let isChecked = permObj.hasOwnProperty(n.id) ? permObj[n.id].indexOf(db.name) !== -1 ? true : false : false;
                  if (isSendToDirect && n.id === 8) {
                    isChecked = true;
                  }
                  return (
                    <TableCell key={`tccb${ii}`}>
                      <Checkbox
                        tabIndex={-1}
                        checkedIcon={<Check className={classes.checkedIcon} />}
                        icon={<Check className={classes.uncheckedIcon} />}
                        classes={{checked: classes.checked}}
                        disabled={isSendToDirect && n.id === 8}
                        checked={isChecked}
                        onClick={() => {
                          
                          let autoAdd_1 = false;
                          // if Approve BP & Direct to SAP autocheck Create BP
                          if (n.id === 9) {
                            autoAdd_1 = true;
                          }
                          if (permObj.hasOwnProperty(n.id)) {
                            if (permObj[n.id].length > 0) {
                              const indx = permObj[n.id].indexOf(db.name);
                              if (indx === -1) {
                                permObj[n.id].push(db.name);
                              } else {
                                permObj[n.id] = permObj[n.id].filter((d,i) => {
                                  if (i === indx) {
                                    return false;
                                  }
                                  return true;
                                });
                              }
                            }
                          } else {
                            permObj[n.id] = [db.name];
                          }

                          if (autoAdd_1) {
                            if (permObj.hasOwnProperty(8)) {
                              if (permObj[8].length > 0) {
                                const indx = permObj[8].indexOf(db.name);
                                if (indx === -1) {
                                  permObj[8].push(db.name);
                                }
                              }
                            } else {
                              permObj[8] = [db.name];
                            }
                          }

                          let newPermObj = {};
                          Object.keys(permObj).forEach((perm_id) => {
                            if (permObj[perm_id].length !== 0) {
                              newPermObj[perm_id] = permObj[perm_id];
                            }
                          });
                          props.choosePerm(newPermObj);
                          
                        }}
                      />
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
          {props.actions.length > 1 && <TableRow>
            <TableCell>
              <div style={{textAlign:'left'}}><strong>Select ALL</strong></div>
            </TableCell>
            {dbList.map((db, ii) => {
              let isAllChecked = true;
              props.actions.forEach((n, i) => {
                if (!permObj.hasOwnProperty(n.id)) {
                  isAllChecked = false;
                } else {
                  if (permObj[n.id].indexOf(db.name) === -1) {
                    isAllChecked = false;
                  }
                }
              });
              return (
                <TableCell key={`tcceb${ii}`}>
                  <Checkbox
                    tabIndex={-1}
                    checkedIcon={<Check className={classes.checkedIcon} />}
                    icon={<Check className={classes.uncheckedIcon} />}
                    classes={{checked: classes.checked}}
                    checked={isAllChecked}
                    onClick={() => {
                      
                      if (!isAllChecked) {
                        
                        props.actions.forEach((n, i) => {
                          if (permObj.hasOwnProperty(n.id)) {
                            if (permObj[n.id].length > 0) {
                              const indx = permObj[n.id].indexOf(db.name);
                              if (indx === -1) {
                                permObj[n.id].push(db.name);
                              }
                            }
                          } else {
                            permObj[n.id] = [db.name];
                          };
                          
                          let newPermObj = {};
                          Object.keys(permObj).forEach((perm_id) => {
                            if (permObj[perm_id].length !== 0) {
                              newPermObj[perm_id] = permObj[perm_id];
                            }
                          });
                          
                          props.choosePerm(newPermObj);
                        });
                      } else {
                        props.actions.forEach((n, i) => {
                          
                          if (permObj.hasOwnProperty(n.id)) {
                            
                            if (permObj[n.id].length > 0) {

                              const indx = permObj[n.id].indexOf(db.name);
                              
                              if (indx !== -1) {
                                
                                permObj[n.id] = permObj[n.id].filter((r,i) => {
                                  if (i === indx) {
                                    return false;
                                  }
                                  return true;
                                });
                              }
                            }
                          }
                          let newPermObj = {};
                          Object.keys(permObj).forEach((perm_id) => {
                            if (permObj[perm_id].length !== 0) {
                              newPermObj[perm_id] = permObj[perm_id];
                            }
                          });
                          props.choosePerm(newPermObj);
                        });
                      }
                    }}
                  />
                </TableCell>
              );
            })}
          </TableRow>}
      </TableBody>
    </Table>
  </div>
  )
}

const UserMatrix = props => {
  
  const { classes } = props;
  const id = props.actions[0].id,
        name = props.actions[0].name;
  let permObj = JSON.parse(JSON.stringify(props.permObj));

  // singles = no DBs
  // hasDBs = multiple DB checkboxes
  const singles = props.actions.filter(act => {
    if (!act.hasDBs) {
      return true;
    }
  });
  const hasDBs = props.actions.filter(act => {
    if (act.hasDBs) {
      return true;
    }
  });

  let singlesGrouped = {};
  singles.forEach(act => {
    if (act.subCategory) {
      if (singlesGrouped.hasOwnProperty(act.subCategory)) {
        singlesGrouped[act.subCategory].push(act);
      } else {
        singlesGrouped[act.subCategory] = [act];
      }
    }
  });

  let hasDBsGrouped = {};
  hasDBs.forEach(act => {
    if (act.subCategory) {
      if (hasDBsGrouped.hasOwnProperty(act.subCategory)) {
        hasDBsGrouped[act.subCategory].push(act);
      } else {
        hasDBsGrouped[act.subCategory] = [act];
      }
    }
  });

  
  
  const singleRenders = Object.keys(singlesGrouped).map((category, i) => {
    
    return <Single
            key={`singles${i}`}
            permObj={permObj}
            classes={classes}
            choosePerm={props.choosePerm}
            actions={singlesGrouped[category]}
          />;
  });

  const hasDBsRenders = Object.keys(hasDBsGrouped).map((category, i) => {
    return <HasDBs
              key={`multiples${i}`}
              permObj={permObj}
              classes={classes}
              choosePerm={props.choosePerm}
              actions={hasDBsGrouped[category]}
            />
  });

  return (
    <div className="tiny-table2" style={{paddingLeft:'10px'}}>
    {hasDBsRenders}
    {singleRenders}
    </div>
  );
}

export default withStyles(styles)(UserMatrix);
